import { useEffect, useState } from 'react'
import { ChevronUp } from 'lucide-react'

export default function SiteScrollToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      aria-label="Scroll to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={
        'fixed right-4 bottom-24 sm:bottom-20 z-50 w-11 h-11 rounded-2xl flex items-center justify-center border border-slate-200 bg-white shadow-sm text-brand-primary transition ' +
        (visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none')
      }
    >
      <ChevronUp size={18} />
    </button>
  )
}

